import { normalizeResourceId } from "./GeneralFunctions.js";

function isProductInCart(currentCartOrder, productId) {
  const normalizedProductId = normalizeResourceId(productId);

  if (!normalizedProductId) {
    return false;
  }

  const orderLines = currentCartOrder?.orderLines?.edges || [];

  return orderLines.some((edge) => {
    const cartProductId = edge?.node?.productId;
    return normalizeResourceId(cartProductId) === normalizedProductId;
  });
}

function getOwnedBookshelfItem(bookshelf, productId, currentCartOrder) {
  const normalizedProductId = normalizeResourceId(productId);

  if (!normalizedProductId) {
    return null;
  }

  const ownedBook = (bookshelf || []).find((book) => {
    return normalizeResourceId(book?.id) === normalizedProductId;
  });

  if (!ownedBook) {
    return null;
  }

  // Items in the cart are treated as not yet owned so they still show
  // the "buy" UI. This hides the owned state if a user re-purchases a book
  // they already own, but that edge case is acceptable.
  if (isProductInCart(currentCartOrder, productId)) {
    return null;
  }

  return ownedBook;
}

function filterOwnedBookshelfItems(bookshelf, currentCartOrder) {
  return (bookshelf || []).filter((book) => {
    return !isProductInCart(currentCartOrder, book?.id);
  });
}

export {
  filterOwnedBookshelfItems,
  getOwnedBookshelfItem,
  isProductInCart,
};
